import { render, staticRenderFns } from "./PartnersTableItem.vue?vue&type=template&id=2f36a360&scoped=true"
import script from "./PartnersTableItem.vue?vue&type=script&lang=js"
export * from "./PartnersTableItem.vue?vue&type=script&lang=js"
import style0 from "./PartnersTableItem.vue?vue&type=style&index=0&id=2f36a360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f36a360",
  null
  
)

export default component.exports